import { Detail } from '../../create-request/models/pdf/Detail';
import { pdfLabelsSubmitDetails } from './Constants';

export const getArrayBufferFromBase64 = (base64: string) => {
  var binary = window.atob(base64);
  var bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes.buffer;
};

export const openPdfInNewWindow = (pdf: Blob, isAttestationPdf: boolean) => {
  // for other browsers not IE
  let url = URL.createObjectURL(pdf);
  if (isAttestationPdf) {
    window.open(
      url,
      '_blank',
      'left=300,width=700,height=500,resizable=1,scrollbars=1,toolbar=0,location=0,menubar=0'
    );
  } else {
    window.open(
      url,
      '_blank',
      'width=700,height=500,resizable=1,scrollbars=1,toolbar=0,location=0,menubar=0'
    );
  }
};

/**
 * Method that takes id and className as params and returns toDetails and submitDetails required for LOA request
 * @param id Id of the html tag
 * @param className Class used to check if the tag need to be included in LOA request
 * @returns List of toDetails and submitDetails required for LOA request
 */
export const getAllLoaFieldDetails = (
  id: string,
  className: string
): {
  toDetails: Detail[];
  submitDetails: Detail[];
  createSloaDetails: Detail[];
} => {
  const element = document.getElementById(id);
  const toDetails: Detail[] = [];
  const submitDetails: Detail[] = [];
  const createSloaDetails: Detail[] = [];
  if (!element) {
    return { toDetails, submitDetails, createSloaDetails };
  }

  const allLoaLabelGroups: HTMLElement[] = [
    ...Array.from(element.querySelectorAll<HTMLElement>(`mm-label-group.${className}`)),
    ...Array.from(element.querySelectorAll<HTMLElement>(`mm-condensed-label-group.${className}`))
  ];

  // Fallback for condensed wire transmission notes when LOA classes are not present on the host element.
  const condensedTransmissionNotes = document.getElementById('wiresCondensed_transmissionNotes');
  if (condensedTransmissionNotes && !allLoaLabelGroups.includes(condensedTransmissionNotes)) {
    allLoaLabelGroups.push(condensedTransmissionNotes);
  }
  
  allLoaLabelGroups.forEach((elem) => {
    const isCondensedTransmissionNotes = elem.id === 'wiresCondensed_transmissionNotes';
    const loaElement = elem as HTMLElement & { loafieldname?: string };
    const spanElement = elem.getElementsByTagName('span');
    const value: string[] =
      spanElement.length > 0
        ? Array.from(spanElement).map((span) => span.innerText)
        : [];
    const name =
      loaElement.loafieldname ??
      elem.dataset.loafieldname ??
      (isCondensedTransmissionNotes ? pdfLabelsSubmitDetails.additionalWireInstructions : '');
    const detail = new Detail(name, value);

    if (elem.classList.contains('loaToDetails')) {
      toDetails.push(detail);
    } else if (elem.classList.contains('loaSubmitDetails') || isCondensedTransmissionNotes) {
      submitDetails.push(detail);
    }

    if (elem.classList.contains('loaCreateSloaDetails')) {
      createSloaDetails.push(detail);
    }
  });

  return { toDetails, submitDetails, createSloaDetails };
};
